import { merge, Observable, fromEvent } from 'rxjs'
import { map, mergeMap, filter } from 'rxjs/operators'
import { StateObservable } from 'redux-observable'
import { SyncClient } from 'twilio-sync'
import { ReduxAction, State } from '../../../reducers/reducerType'
import syncActions, { handleSyncConnectionStateChange } from '../../../actions/sync/syncActions'
import { ConnectionState } from 'twilio-sync'

const dataEvents$ = (client: SyncClient, state$: StateObservable<State>): Observable<ReduxAction> => merge(
  fromEvent<ConnectionState>(client, 'connectionStateChanged')
    .pipe(
      map((connectionState: ConnectionState) => handleSyncConnectionStateChange(connectionState, client, state$.value.config.token ?? ''))
    ),
  fromEvent<SyncClient>(client, 'tokenAboutToExpire')
    .pipe(
      filter(() => state$.value.config.roomname !== null && state$.value.config.username !== null),
      // @ts-ignore
      mergeMap(() => syncActions.renewToken(client, state$.value.config.roomname || '', state$.value.config.username || ''))
    )
)

export default dataEvents$
